/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import injectReducer from '../../../utils/injectReducer';
import EdgeIneligible from '../../../components/Web/CreditcheckEdgeIneligible/index';
import edgeIneligible from '../reducer';
import { getPlansData } from '../../../utils/plansReference/index';
import injectSaga from '../../../utils/injectSaga';
import * as creditEdgeActions from '../actions';
import edgeIneligibleSaga from '../sagas';

const mapStateToProps = (state) => {
  const cartState = state.cartDetails ? state.cartDetails.cartDetailsJson : {};
  const dueTodayList = state.cartDetails ? state.cartDetails.cartDetailsJson.dueTodayList : {};
  const orderDetailsState = state.cartDetails ? state.cartDetails.cartDetailsJson.orderDetailsView : {};
  const shippingDetailsState = state.cartDetails ? state.cartDetails.cartDetailsJson.shippingDetails : {};
  const dueTodayTaxesState = state.cartDetails ? state.cartDetails.cartDetailsJson.dueTodayTaxes : {};
  const plansReferenceData = getPlansData(state.plansReferenceData);
  const currentView = state.currentView || {};
  const dueMonthlyList = state.cartDetails ? state.cartDetails.cartDetailsJson.dueMonthlyList : {};
  const dueMonthlyorderDetailsView = state.cartDetails ? state.cartDetails.cartDetailsJson.orderDetailsView : {};
  const dueMonthlyTaxes = state.cartDetails ? state.cartDetails.cartDetailsJson.dueMonthlyTaxes : {};

  return {
    cartDetails: cartState || [],
    orderDetails: orderDetailsState || {},
    shippingDetails: shippingDetailsState || {},
    dueTodayTaxesDetails: dueTodayTaxesState || {},
    plansReferenceData: plansReferenceData || {},
    dueTodayList,
    currentView,
    dueMonthlyList,
    dueMonthlyorderDetailsView,
    dueMonthlyTaxes,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...creditEdgeActions,
    },
    dispatch,
  );
}

const withSaga = compose(injectSaga({ key: 'EdgeIneligible', saga: edgeIneligibleSaga }));

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = compose(injectReducer({ key: 'edgeIneligible', reducer: edgeIneligible }));

export default withRouter(
  compose(
    withSaga,
    withReducer,
    withConnect,
  )(EdgeIneligible),
);
